import { useSyncExternalStore } from "react";

import type { ErrorDetails } from "./errors.ts";

export type PersistenceStatus =
  | { type: "idle" }
  | { type: "working" }
  | { type: "retrying"; attemptCount: number; retryInMs: number; retryNow: () => void }
  | {
      type: "retriesExhausted";
      attemptCount: number;
      errorDetails: ErrorDetails;
      dismiss: () => void;
      retry: () => void;
    }
  | { type: "failed"; errorDetails: ErrorDetails; dismiss: () => void };

let persistenceStatus: PersistenceStatus = { type: "idle" };

export const getPersistenceStatus = () => persistenceStatus;

export const setPersistenceStatus = (newStatus: PersistenceStatus) => {
  persistenceStatus = newStatus;
  for (const notify of subscribers) {
    notify();
  }
};

const subscribers = new Set<() => void>();

const subscribe = (callback: () => void) => {
  subscribers.add(callback);
  return () => {
    subscribers.delete(callback);
  };
};

export const usePersistenceStatus = () => {
  return useSyncExternalStore(subscribe, getPersistenceStatus);
};
